/**
 * penColors — curated palette for the Memory Snap product.
 *
 * Strictly NO RGB picker per /app/brand/originals.md. These ten colours
 * cover the emotional spectrum across the four event archetypes
 * (Wedding / Year6 / Prom / Corporate) AND can serve as a fallback
 * universal palette when an event has no theme set.
 *
 * Per-theme defaults are applied at component-mount via `defaultsForTheme`.
 * The order matters — these are rendered as a horizontal scroll of pen
 * dots, so we want the most emotionally-default colour first per theme.
 */

export const PEN_COLORS = [
  { id: 'black',     hex: '#1A1A1A', label: 'Black'        },
  { id: 'white',     hex: '#FFFFFF', label: 'White'        },
  { id: 'gold',      hex: '#D4AF5E', label: 'Gold'         },
  { id: 'pink',      hex: '#F472B6', label: 'Soft Pink'    },
  { id: 'lavender',  hex: '#A78BFA', label: 'Lavender'     },
  { id: 'sky',       hex: '#3B82F6', label: 'Sky Blue'     },
  { id: 'teal',      hex: '#14B8A6', label: 'Teal'         },
  { id: 'sage',      hex: '#65A30D', label: 'Sage Green'   },
  { id: 'coral',     hex: '#F87171', label: 'Coral'        },
  { id: 'silver',    hex: '#D1D5DB', label: 'Silver'       },
];

export const findPen = (id) => PEN_COLORS.find((p) => p.id === id) || PEN_COLORS[2]; // default gold

// Per-event-type defaults — the FIRST item is the suggested starting pen.
export const defaultsForTheme = (eventType) => {
  const t = String(eventType || '').toLowerCase();
  if (t.includes('wedding'))     return ['gold', 'white', 'black'];
  if (t.includes('year6') || t.includes('school') || t.includes('leavers')) return ['sky', 'lavender', 'pink'];
  if (t.includes('prom'))        return ['silver', 'gold', 'lavender'];
  if (t.includes('corporate'))   return ['black', 'white', 'gold'];
  // Universal fallback — neutral first.
  return ['gold', 'white', 'black'];
};

// Soft emotional prompts — rotated as placeholder. Per spec, NOT loud.
export const MESSAGE_PROMPTS = [
  'Best night ever',
  'Never forget this',
  'Love you guys',
  'What a night',
  'Year 6 forever',
  'So much love',
  'Memories we made',
  'Tonight was magic',
];
